module.exports = __webpack_public_path__ + "img/buy-me-a-coffee.9c65c320.svg";